<!-- 选择题(图片,拼音,文字) -->
<template>
  <div class="ques-area" v-if="isReady">
    <div class="example" v-if="!isSPC">
      {{ jsonData.is_example ? $t("hsk_example") : jsonData.index }}
    </div>
    <div class="ques-area-des" v-if="descriptionText">{{ serial ? serial + ". " : "" }}{{ descriptionText }}</div>
    <div class="panel-content">
      <slot></slot>
      <div class="text-ques">
        <div v-for="(item, index) in jsonData.screen_text" :key="index" :class="`describe--${item.type}`">
          <img v-if="item.type == 'image'" :src="baseUrl + item.content + '?width=300'" alt="" />
          <PhoneticText
            v-if="item.type === 'html' || item.type === 'text'"
            :originData="item.content"
            :baseStyles="textStyles(item)"
            :showPinyin="item.type == 'text' ? false : item.display != 1"
            :onlyPinyin="item.display == 2"
          ></PhoneticText>
          <div v-else-if="item.type == 'syllable'">{{ item.content }}</div>
        </div>
      </div>
      <div class="panel-content-answers">
        <ul class="list-answers" :style="{ flexDirection: directionFlag ? 'row' : 'column' }" ref="answers">
          <li
            v-for="(item, index) in jsonData.answers"
            :class="[
              `item-answer--${item.type === 'text' ? 'html' : item.type}`,
              {
                success: isShowAnAnalysis && item.correct,
                error: isShowAnAnalysis && !item.correct && isHomeworkError && myAnswerText === item.flag,
                selected: (!isShowAnAnalysis && item.selected) || (jsonData.is_example && item.correct),
              },
            ]"
            :key="`${item.index}_${index}`"
            :data-correct="item.correct ? 1 : 0"
            ref="answer"
            @click="handleCheck($event, item)"
          >
            <div v-if="item.type === 'image'">
              <div class="item-key">{{ item.flag }}</div>
              <img :src="baseUrl + item.content + '?width=300'" alt="" />
            </div>
            <div v-else-if="item.type == 'html' || item.type == 'text'">
              <div class="item-key" :class="[item.content ? '' : 'item-key-center']">
                {{ item.flag }}
              </div>
              <PhoneticText
                :originData="item.content"
                :baseStyles="smallTextStyles"
                :showPinyin="item.type == 'text' ? false : item.display != 1"
                :onlyPinyin="item.display == 2"
              ></PhoneticText>
            </div>
            <div v-else-if="item.type == 'syllable'">
              <div class="item-key">{{ item.flag }}</div>
              <div>{{ item.content }}</div>
            </div>
          </li>
        </ul>
      </div>
      <!-- 解析 -->
      <div class="panel-content-result result-correct" v-if="isShowAnAnalysis && !isError && !jsonData.is_example">
        <p class="correct-tips">
          {{ $t("textbook_chioce_word_text_correct_tip") }}
        </p>
        <div class="correct-box" v-show="analysisText">
          <p class="correct-box-title">{{ $t("hsk_answer_analysis") }}</p>
          <p class="correct-box-answer">
            {{ analysisText }}
          </p>
        </div>
      </div>

      <div class="panel-content-result result-error" v-if="isShowAnAnalysis && isError && !jsonData.is_example">
        <p class="error-tips">
          {{ $t("textbook_chioce_word_text_error_tip") }}
        </p>
        <div class="result-show">
          <div class="your-answer">{{ $t("hsk_your_answer") }}{{ myAnswerText }}</div>
          <p class="correct-answer">{{ $t("hsk_correct_answer") }}{{ successAnswerText }}</p>
        </div>
        <div class="correct-box" v-show="analysisText">
          <p class="correct-box-title">{{ $t("hsk_answer_analysis") }}</p>
          <p class="correct-box-answer">
            {{ analysisText }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mixinCommon } from "@/mixins";
import PhoneticText from "@/components/ui/phoneticText";
// import { AI_COURSE_AUDIO_ROOT_PATH } from '@/config'
export default {
  name: "CommonChoice",
  components: { PhoneticText },
  mixins: [mixinCommon],
  data() {
    return {
      // 作业是否答题正确
      isHomeworkError: false,
    };
  },
  created() {
    this.jsonData.answers = this.resetAnswerSelected(this.jsonData.answers);
    if (this.jsonData.answer) {
      this.jsonData.answers = this.selectedAnswer(this.jsonData.answer);
    }
    if (this.jsonData.listen) {
      this.jsonData.screen_text.push({
        type: "audio",
        content: this.jsonData.listen.audio_file,
      });
    }
  },
  computed: {
    isError() {
      let flag = "";
      if (this.jsonData.answer) {
        for (let i = 0; i < this.jsonData.answers.length; i++) {
          if (this.jsonData.answers[i].correct && this.jsonData.answers[i].id == this.jsonData.answer) {
            flag = this.jsonData.answers[i].id;
            break;
          }
        }
      }
      return this.jsonData.answer != flag || (this.jsonData.answer == "" && this.jsonData.answer != undefined);
    },
    successAnswerText() {
      // 计算正确答案项
      let correctObj = this.jsonData.answers.find((item) => {
        return item.correct;
      });
      return correctObj.flag;
    },
    myAnswerText() {
      let flag = "";
      if (this.jsonData.answer) {
        for (let i = 0; i < this.jsonData.answers.length; i++) {
          if (this.jsonData.answers[i].index == this.jsonData.answer) {
            flag = this.jsonData.answers[i].flag;
            break;
          }
        }
      }
      return flag;
    },
    language() {
      let local = localStorage.getItem("language");
      return local;
    },
    analysisText() {
      return this.jsonData.analysis[this.language]
        ? this.jsonData.analysis[this.language]
        : this.jsonData.analysis["cn"];
    },
    // 是否数据处理完成
    isReady() {
      return !!this.jsonData;
    },
    ifSelected() {
      return !!this.jsonData.answers.find((item) => {
        return item.selected;
      });
    },
    directionFlag() {
      return this.jsonData.answers.some((item) => {
        return item.type === "image";
      });
    },
    descriptionText() {
      return this.jsonData.question_description_obj
        ? this.jsonData.question_description_obj[this.language]
          ? this.jsonData.question_description_obj[this.language]
          : this.jsonData.question_description_obj["zh"]
        : "";
    },
  },
  methods: {
    //点击选项
    handleCheck(event, item) {
      const isCorrect = !!parseInt(event.currentTarget.dataset.correct);
      if (this.isShowAnAnalysis || this.jsonData.is_example) {
        return;
      }
      this.isHomeworkError = !isCorrect;

      this.jsonData.answers = this.selectedAnswer(item.id);
      const { index, score, segment_code, part_code, ifGroup } = this.jsonData;
      let params = {
        answer: item.id,
        questionId: index,
        scores: isCorrect ? score : 0,
        judge: isCorrect ? 1 : 0,
        segmentCode: segment_code,
        partCode: part_code,
        ifGroup: ifGroup,
      };
      this.$emit("customInterface", params);
      setTimeout(() => {
        this.$emit("saveRes", params);
      }, 200);
    },
    //点击选项置为true
    selectedAnswer(chooseIndex) {
      return this.jsonData.answers.map((item) => {
        if (chooseIndex == item.id) {
          item.selected = true;
        } else {
          item.selected = false;
        }
        console.log(item);
        return item;
      });
    },
    //重置选项为未点击
    resetAnswerSelected() {
      return this.jsonData.answers.map((item) => {
        item.selected = false;
        return {
          id: item.index,
          index: item.id,
          ...item,
        };
      });
    },
    playAudio() {
      this.$emit("changeShowButtonStatus", "pause");
      // 检查是否存在音频，有的化播放
      let videoObj = this.jsonData.screen_text.find((item) => {
        return item.type === "audio";
      });
      if (videoObj) {
        let url =
          videoObj.content.indexOf("https") > -1
            ? videoObj.content
            : this.baseUrl
            ? this.baseUrl + videoObj.content
            : videoObj.content; //AI_COURSE_AUDIO_ROOT_PATH +
        this.$player.play(url);
        console.log(url);
        this.$player.onended = () => {
          this.$emit("changeShowButtonStatus", "play");
        };
      }
    },
    pauseAudio() {
      this.$player.pause();
      this.$emit("changeShowButtonStatus", "play");
    },
  },
};
</script>
<style lang="scss" scoped>
.ques-area {
  width: 100%;
  position: relative;
  padding-top: 45px;
  min-height: 400px;
  &-des {
    position: absolute;
    left: 37px;
    top: 20px;
    font-size: 14px;
    font-weight: 400;
    line-height: 24px;
    color: #b5b5be;
    margin-top: 0px;
  }
  .example {
    background: rgba(63, 70, 81, 1);
    border-radius: 4px;
    color: #fff;
    padding: 5px;
    font-size: 12px;
    position: absolute;
    top: 40px;
    left: 28px;
    min-width: 20px;
    display: flex;
    justify-content: center;
  }
  .panel-content {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 0px 29px 0px 29px;
    img {
      width: 172px;
      height: 96px;
      object-fit: contain;
      border-radius: 6px;
    }
    .text-ques {
      padding-top: 15px;
      .describe {
        &--html,
        &--text {
          margin-bottom: 15px;
          ::v-deep .phtContent {
            .normal_pht {
              //display: inline-flex;
              .pht_single {
                text-align: start;
              }
            }
          }
        }
        &--image {
          text-align: center;
          margin-bottom: 20px;
        }
      }
    }
    &-answers {
      width: 100%;
      margin-top: 20px;
      margin-bottom: 40px;
      .list-answers {
        display: flex;
        justify-content: center;
        align-items: center;
        min-height: 200px;
      }

      .item-answer {
        &--image {
          cursor: pointer;
          position: relative;

          display: flex;
          align-items: center;
          justify-content: center;
          width: 176px;
          height: 100px;
          border: 2px solid #fff;
          margin-top: 20px;
          margin: 5px;
          color: rgba(63, 70, 81, 1);
          background: rgba(242, 243, 247, 1);
          border-radius: 6px;
          box-sizing: border-box;
          .text {
            overflow: hidden;
            text-overflow: ellipsis;
          }
          .item-key {
            width: 46px;
            height: 27px;
            line-height: 27px;
            text-align: center;
            color: #ffffff;
            background: rgba(0, 0, 0, 0.6);
            border-radius: 4px 0px 4px 0px;
            position: absolute;
            top: 0px;
            left: 0px;
          }
          &:after {
            position: absolute;
            content: "";
            width: 16px;
            height: 16px;
            right: 78px;
            bottom: -40px;
            transform: translateY(-50%);
            background-position: 0 0;
            background-repeat: no-repeat;
            background-size: cover;
          }
          &.selected {
            border: 2px solid #faae56;
            background: #ffffff;
          }
          &.success {
            background: #ffffff; // 设置白色背景
            border: 2px solid rgba(9, 203, 160, 1);
            color: #09cba0;

            // &:after {
            //   background-image: url(~@/assets/images/icon-test-ok.png);
            // }
          }

          &.error {
            border: 2px solid rgba(253, 148, 63, 1);
            color: #fc5a5a;
            background: #ffffff;
            // &:after {
            //   background-image: url(~@/assets/images/icon-test-no.png);
            // }
          }
        }
        &--html,
        &--text,
        &--syllable {
          cursor: pointer;
          position: relative;
          display: flex;
          align-items: center;
          padding: 10px 20px 10px 40px;
          width: 306px;
          min-height: 50px;
          border: 2px solid #fff;
          margin-top: 20px;
          margin: 5px;
          color: rgba(63, 70, 81, 1);
          background: rgba(242, 243, 247, 1);
          border-radius: 6px;
          box-sizing: border-box;
          ::v-deep .phtContent {
            .pht_single {
              text-align: start;
              margin-bottom: 0 !important;
              // 兼容sarfir
              p > span {
                display: flex;
                flex-wrap: wrap;
              }
            }
          }
          .text {
            overflow: hidden;
            text-overflow: ellipsis;
          }
          .item-key {
            position: absolute;
            font-size: 16px;
            font-weight: 600;
            color: rgba(174, 186, 198, 1);
            left: 16px;
            top: 50%;
            transform: translateY(-50%);
          }
          .item-key-center {
            position: absolute;
            font-size: 16px;
            font-weight: 600;
            color: rgba(174, 186, 198, 1);
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
          }
          &:after {
            position: absolute;
            content: "";
            width: 16px;
            height: 16px;
            right: -24px;
            top: 50%;
            transform: translateY(-50%);
            background-position: 0 0;
            background-repeat: no-repeat;
            background-size: cover;
          }
          &.selected {
            border: 2px solid #faae56;
            background: #ffffff;
            // ::v-deep .phtContent > .normal_pht > .pht_single > .pinyin > span {
            //   color: #1c84fe !important;
            //   span {
            //     color: #1c84fe !important;
            //   }
            // }
            // ::v-deep .phtContent > .normal_pht > .pht_single > .hz > span {
            //   color: #1c84fe !important;
            //   span {
            //     color: #1c84fe !important;
            //   }
            // }
          }
          &.success {
            background: #ffffff; // 设置白色背景
            border: 1px solid rgba(9, 203, 160, 1);
            color: #09cba0;

            // &:after {
            //   background-image: url(~@/assets/images/icon-test-ok.png);
            // }
            ::v-deep .phtContent > .normal_pht > .pht_single > .pinyin span {
              color: #09cba0 !important;
            }
            ::v-deep .phtContent > .normal_pht > .pht_single > .hz span {
              color: #09cba0 !important;
            }
          }

          &.error {
            border: 1px solid #fc5a5a;
            color: #fc5a5a;
            background: #ffffff;
            ::v-deep .phtContent > .normal_pht > .pht_single > .pinyin span {
              color: #fc5a5a !important;
            }
            ::v-deep .phtContent > .normal_pht > .pht_single > .hz span {
              color: #fc5a5a !important;
            }
            // &:after {
            //   background-image: url(~@/assets/images/icon-test-no.png);
            // }
          }
        }
      }
    }
    &-result {
      padding: 40px 30px 20px 0;
      border-top: 1px dashed #e6eaef;
      width: 100%;
      &.result-error,
      &.result-correct {
        p.error-tips {
          font-size: 14px;
          color: #fc5a5a;
          margin-bottom: 20px;
        }
        p.correct-tips {
          font-size: 14px;
          color: rgba(9, 203, 160, 1);
          margin-bottom: 20px;
        }
        .result-show {
          display: flex;
          align-items: center;
          margin-bottom: 20px;
        }
        .your-answer {
          font-size: 14px;
          font-weight: 500;
          color: rgba(84, 89, 97, 1);
          line-height: 14px;
          img {
            width: 12px;
            height: 12px;
            margin-left: 20px;
          }
        }
        p.correct-answer {
          font-size: 14px;
          font-weight: 500;
          color: rgba(84, 89, 97, 1);
          line-height: 14px;
          margin-left: 45px;
        }
        .correct-box {
          background: #fafafb;
          border-radius: 10px;
          padding: 20px;

          &-title {
            font-size: 14px;
            font-weight: bold;
            color: rgba(63, 70, 81, 1);
            margin-bottom: 10px;
          }
          &-answer {
            font-size: 14px;
            font-weight: 400;
            color: rgba(84, 89, 97, 1);
            line-height: 21px;
            white-space: pre-line;
          }
        }
      }
    }
    .input {
      &-box {
        display: flex;
        align-items: center;
        width: 100%;
        flex-wrap: wrap;
        margin-bottom: 15px;
      }
      &-text {
        font-size: 16px;
        font-weight: 400;
        color: #3e4651;
      }
      &-item {
        width: 86px;
        margin: 0px 6px;
        text-align: center;
        padding: 4px 0px;
        border-bottom: 1px solid #3e4651;
        font-size: 16px;
        font-weight: 400;
        color: #3e4651;
      }
    }
  }
}
</style>
